import CircleImage from './CircleImage';

export default CircleImage;
